// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Calculate/components/CalculateHeader/styles.scss
// module id = 1246
// module chunks = 0